import React, { Fragment, Component } from "react";
import { connect } from "react-redux";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Nav from "react-bootstrap/Nav";
import Row from "react-bootstrap/Row";
import moment from "moment";
import ToggleButtonGroup from "react-bootstrap/ToggleButtonGroup";
import Button from "react-bootstrap/Button";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import ToggleButton from "react-bootstrap/ToggleButton";
import ListGroup from "react-bootstrap/ListGroup";
import { editDelivery } from "../actions/deliveryAction";
import ax from "./auth/axios";
import { API_ROOT } from "./utils/api-config";

class ReScheduleDelivery extends Component {
  constructor(props) {
    super(props);
    this.state = {
      deliveryDay: "tod",
      filteredDate: moment(Date.Now).format("YYYY-MM-DD"),
      bdate_id: 0,
      date: "",
      booking_id: 0,
      delivery_window: "",
      merchant_id: 0,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDateClick = this.handleDateClick.bind(this);
    this.handleTimeClick = this.handleTimeClick.bind(this);
  }
  componentDidMount() {
    this.props;
  }
  handleDateClick(newDate) {
    this.setState(() => ({
      filteredDate: newDate,
    }));
  }
  handleTimeClick(newSlot) {
    const clickedSlot = this.props.delivery.timeslots.find(
      (slot) => slot.id === newSlot
    );
    this.setState(() => ({
      booking_id: newSlot,
      delivery_window: clickedSlot.delivery_window,
      bdate_id: clickedSlot.bdate_id,
      date: this.state.filteredDate,
    }));
  }

  redirect = () => {
    this.props.history.push({ pathname: "/logistics" });
  };

  handleSubmit(e) {
    e.preventDefault();
    const formData = new FormData();
    let token = "Bearer " + localStorage.getItem("token");
    const config = {
      headers: {
        Authorization: token,
        "Content-Type": "application/x-www-form-urlencoded",
      },
    };
    formData.append("delivery[booking_id]", this.state.booking_id);
    formData.append("delivery[date]", this.state.date);
    formData.append("delivery[bdate_id]", this.state.bdate_id);
    formData.append("delivery[delivery_window]", this.state.delivery_window);
    formData.append("commit", "reschedule");

    ax.patch(
      `${API_ROOT}/deliveries/${this.props.delivery.delivery.id}`,
      formData,
      config
    ).then((response) => {
      this.props.editDelivery(response.data);
    });
  }

  render() {
    const { delivery, timeslots } = this.props.delivery;
    moment.locale("en-gb");
    const filteredTimeslots = timeslots.filter((slot) => {
      if (this.state.filteredDate == moment(Date.Now).format("YYYY-MM-DD")) {
        return slot.date == this.state.filteredDate;
      } else return slot.date == this.state.filteredDate;
    });

    return (
      <Row className="container-fluid">
        <Col sm="4">
          <Form onSubmit={this.handleSubmit}>
            <Nav className="flex-column">
              <Row>
                <Form.Group as={Col} controlId="formGridMerchant">
                  <Form.Label>Delivery from</Form.Label>
                  <Form.Control
                    readOnly
                    name="merchantName"
                    value={delivery.shipfrom_name}
                  />
                </Form.Group>
              </Row>
              <Row>
                <Form.Group as={Col} controlId="formGridFullName">
                  <Form.Label>Deliver to</Form.Label>
                  <Form.Control
                    name="full_name"
                    readOnly
                    value={`${delivery.shipto_first_name} ${delivery.shipto_last_name}`}
                  />
                </Form.Group>
              </Row>
              <Row>
                <Form.Group as={Col} controlId="formGridFullAddress">
                  <Form.Label>Address</Form.Label>
                  <Form.Control
                    name="address"
                    value={`${delivery.shipto_address1}, ${delivery.shipto_city}, ${delivery.shipto_zip}`}
                    readOnly
                  />
                </Form.Group>
              </Row>
              <Row>
                <Form.Group as={Col} controlId="formGridDate">
                  <Form.Label>Delivery Date</Form.Label>
                  <Form.Control name="date" value={this.state.date} readOnly />
                </Form.Group>
              </Row>
              <Row>
                <Form.Group as={Col} controlId="formGridWindow">
                  <Form.Label>Delivery Window</Form.Label>
                  <Form.Control
                    name="delivery_window"
                    value={this.state.delivery_window}
                    readOnly
                  />
                </Form.Group>
              </Row>
            </Nav>
            <hr />
            <Button variant="primary" type="submit">
              Submit
            </Button>
          </Form>
        </Col>
        <Col sm="8">
          <h6 className="text-center">
            Select a delivery time and let us know what we can do to make your
            delivery perfect.
          </h6>
          <div className="d-flex flex-column">
            <div>
              <ToggleButtonGroup
                name="deliveryDay"
                type="radio"
                className="mt-1 mb-1"
                defaultValue="tod"
              >
                <ToggleButton
                  active
                  variant="outline-info"
                  type="radio"
                  value="tod"
                  onClick={() =>
                    this.handleDateClick(moment(Date.Now).format("YYYY-MM-DD"))
                  }
                >
                  {moment(Date.Now).format("dddd, MMMM Do")}
                </ToggleButton>
                <ToggleButton
                  variant="outline-info"
                  value="tom"
                  onClick={() =>
                    this.handleDateClick(
                      moment(Date.Now).add(1, "days").format("YYYY-MM-DD")
                    )
                  }
                >
                  {moment(Date.Now).add(1, "days").format("dddd, MMMM Do")}
                </ToggleButton>
                <ToggleButton
                  variant="outline-info"
                  value="d+2"
                  onClick={() =>
                    this.handleDateClick(
                      moment(Date.Now).add(2, "days").format("YYYY-MM-DD")
                    )
                  }
                >
                  {moment(Date.Now).add(2, "days").format("dddd, MMMM Do")}
                </ToggleButton>
                <ToggleButton
                  variant="outline-info"
                  value="d+3"
                  onClick={() =>
                    this.handleDateClick(
                      moment(Date.Now).add(3, "days").format("YYYY-MM-DD")
                    )
                  }
                >
                  {moment(Date.Now).add(3, "days").format("dddd, MMMM Do")}
                </ToggleButton>
              </ToggleButtonGroup>
              {filteredTimeslots.map((slot, i) => {
                const renderElement = () => {
                  if (slot.status == "available") return "primary";
                  else if (slot.status == "unavailable") return "danger";
                  else if (slot.status == "inzone only") return "warning";
                  else if (slot.status == "booked") return "secondary";
                  else if (slot.status == "eco") return "success";
                  return null;
                };
                const renderTooltip = (props) => (
                  <Tooltip id="button-tooltip" {...props}>
                    {slot.status}
                  </Tooltip>
                );

                return (
                  <ListGroup
                    key={filteredTimeslots[i].id}
                    className="text-center"
                  >
                    <OverlayTrigger
                      placement="bottom"
                      delay={{ show: 250, hide: 400 }}
                      overlay={renderTooltip}
                    >
                      <ListGroup.Item
                        variant={renderElement()}
                        action={true}
                        onClick={() =>
                          this.handleTimeClick(filteredTimeslots[i].id)
                        }
                      >
                        {filteredTimeslots[i].delivery_window}
                      </ListGroup.Item>
                    </OverlayTrigger>
                  </ListGroup>
                );
              })}
            </div>
          </div>
        </Col>
      </Row>
    );
  }
}
const mapDispatchToProps = (dispatch) => ({
  editDelivery: (delivery) => dispatch(editDelivery(delivery)),
});
export default connect(null, mapDispatchToProps)(ReScheduleDelivery);
